import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../utils/firebaseConfig";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";

export default function Pedidos() {
  const [user, setUser] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser || null);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const cargarPedidos = async () => {
      // Requiere sesión real (no anónimo)
      if (!user || user.isAnonymous) return;

      try {
        const q = query(
          collection(db, "pedidos"),
          where("userId", "==", user.uid),
          orderBy("fecha", "desc")
        );
        const snap = await getDocs(q);
        const pedidosUsuario = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setPedidos(pedidosUsuario);
      } catch (error) {
        console.error("Error cargando pedidos:", error);
        // Si Firestore te pide índice, sigue el link que da en consola para crearlo.
      }
    };

    cargarPedidos();
  }, [user]);

  const handleVolver = () => {
    if (window.history.length > 2) navigate(-1);
    else navigate("/");
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="bg-white p-6 rounded shadow text-center max-w-lg mx-auto">
          <h2 className="text-xl font-bold text-sky-700">Inicia sesión para continuar</h2>
          <p className="text-gray-600 mt-2">Debes iniciar sesión para ver tus pedidos recientes.</p>
          <button
            onClick={handleVolver}
            className="mt-4 px-4 py-2 bg-sky-700 text-white rounded hover:bg-sky-800"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }

  if (user.isAnonymous) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="bg-white p-6 rounded shadow text-center max-w-lg mx-auto">
          <h2 className="text-xl font-bold text-sky-700">Inicia sesión</h2>
          <p className="text-gray-600 mt-2">
            Estás navegando como invitado. Inicia sesión para ver tus pedidos anteriores.
          </p>
          <button
            onClick={handleVolver}
            className="mt-4 px-4 py-2 bg-sky-700 text-white rounded hover:bg-sky-800"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-semibold text-sky-800 mb-4">Tus pedidos recientes</h2>

        {pedidos.length === 0 ? (
          <p className="text-gray-500">No hay pedidos registrados con esta cuenta.</p>
        ) : (
          <ul className="space-y-4">
            {pedidos.map((pedido, index) => (
              <li key={pedido.id || index} className="bg-white p-4 rounded shadow">
                <p className="text-gray-800 font-semibold">
                  Pedido #{index + 1} {pedido.id ? `• ${pedido.id}` : ""}
                </p>
                <p className="text-sm text-gray-600">
                  Fecha:{" "}
                  {pedido.fecha
                    ? new Date(
                        pedido.fecha.toDate ? pedido.fecha.toDate() : pedido.fecha
                      ).toLocaleString()
                    : "Sin fecha"}
                </p>
                <p className="text-sm text-gray-600">
                  Total: Q{Number(pedido.total || 0).toFixed(2)}
                </p>
                {Array.isArray(pedido.productos) && pedido.productos.length > 0 && (
                  <ul className="text-sm mt-2 ml-4 list-disc">
                    {pedido.productos.map((item, i) => (
                      <li key={i}>
                        {item.nombre} (x{item.cantidad}){item.precio ? ` - Q${item.precio}` : ""}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}


